<template>
  <div>
    <base-title title="查询条件"></base-title>
    <div class="form">
     <el-input
        clearable
        v-model="params.account_name"
        placeholder="用户名"
      ></el-input>
      <el-select
        v-model="params.role_id"
        clearable
        placeholder="用户组"
      >
        <el-option
          v-for="item in options.role_arr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="params.platform_id"
        clearable
        placeholder="来源平台"
      >
        <el-option
          v-for="item in options.platform_arr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="params.status"
        clearable
        placeholder="用户状态"
      >
        <el-option
          v-for="item in options.status_arr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-date-picker
        v-model="params.createTime"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="创建时间"
        style="margin-right: 10px"
        end-placeholder="创建时间">
      </el-date-picker>
      <el-date-picker
        v-model="params.loginTime"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="最后登录时间"
        style="margin-right: 10px"
        end-placeholder="最后登录时间">
      </el-date-picker>
      <el-button type="primary" plain @click="loadData({ page:1 })">查询</el-button>
      <el-button type="default" plain @click="resetBtn">重置</el-button>
    </div>
    <base-title :title="resultTitle"/>
    <div class="btn_box">
      <el-button>
        <a :href="`/home/user/listExport?${loadParams}`" target="_blank" class="download">导出列表</a>
      </el-button>
    </div>
    <base-table
      :data="list"
      :loading="tableLoading"
      :columns="columns"
      v-model="query"
      :total="total"
      @input="loadData"
    >
    <el-table-column
       type="index"
       label="序号"
       align="center"
       width="50">
     </el-table-column>
      <template v-slot:operate="{ row }">
        <span>
          <el-button type="text link" @click="actionTableEditor(row)">查看</el-button>
        </span>
      </template>
      <template v-slot:account_name="{ row }">
        <span @click="actionTableEditor(row)" class="download">
          {{ row.account_name}}
        </span>
      </template>
    </base-table>
    <userDetail
      :visible="isShow"
      @close="isShow=false"
      :options="options"
      :detail="detail"/>
  </div>
</template>

<script>
import { userManageList } from 'index/api'
import qs from 'qs'
import userDetail from './components/userdetail.vue'
export default {
  name: 'userList',

  components: {
    userDetail
  },

  data () {
    return {
      isShow: false,
      resultTitle: '查询结果',
      tableLoading: true,
      detail: {},
      options: {
        platform_arr: [],
        role_arr: [],
        status_arr: [],
        permission_arr: [] // 功能权限
      },
      query: {
        page: 1,
        size: 10
      },
      params: {
        account_name: '',
        role_id: '',
        platform_id: '',
        status: '',
        createTime: [],
        loginTime: []
      },
      list: [],
      total: 0,
      loadParams: {},
      columns: [
        {
          label: '用户名',
          width: '150px',
          prop: 'account_name',
          slotName: 'account_name'
        },
        {
          label: '用户组',
          width: '150px',
          prop: 'roles_str'
        },
        {
          label: '来源平台',
          width: '150px',
          prop: 'platform_name'
        },
        {
          label: '管理项目',
          width: '150px',
          prop: 'projects_str'
        },
        {
          label: '邮箱',
          prop: 'email'
        },
        {
          label: '手机号',
          width: '120px',
          prop: 'phone'
        },
        {
          label: '用户状态',
          prop: 'status_str',
          width: 120
        },
        {
          label: '最后登录时间',
          prop: 'latest_login_time',
          width: 150
        },
        {
          label: '创建时间',
          prop: 'created_at',
          width: 150
        },
        {
          label: '更新时间',
          prop: 'updated_at',
          width: 150
        },
        {
          label: '操作人',
          prop: 'operate_user'
        },
        {
          label: '操作',
          prop: 'operate',
          slotName: 'operate',
          fixed: 'right'
        }
      ]
    }
  },
  created () {
    this.getRegion()
    this.loadData()
  },
  methods: {
    actionTableEditor (row) {
      this.detail = row
      this.isShow = true
    },
    async loadData (parmas) {
      this.tableLoading = true
      const { createTime, loginTime } = this.params
      const [ created_at_start, created_at_end ] = createTime
      const [ last_login_start, last_login_end ] = loginTime
      this.loadParams = qs.stringify({ ...this.params, created_at_start, created_at_end, last_login_start, last_login_end, ...this.query, ...parmas })
      const { total, list } = await userManageList({ ...this.params, created_at_start, created_at_end, last_login_start, last_login_end, ...this.query, ...parmas })
      this.total = total
      this.list = list
      this.tableLoading = false
    },
    resetBtn () {
      this.params = {
        account_name: '',
        role_id: '',
        platform_id: '',
        status: '',
        createTime: [],
        loginTime: []
      }
      this.query.page = 1
      this.loadParams = {}
      this.loadData()
    },
    getRegion () {
      this.axios.get('/home/user/filterConditionList').then(({ data }) => {
        Object.keys(data).map(item => {
          this.options[item] = data[item]
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-table {
  margin: 10px 20px;
}
::v-deep .el-select, .el-input{
  width: 120px;
  margin-right: 15px;
  margin-bottom: 10px;
}
.download{
  cursor: pointer;
  color:#1890ff;
}
.btn_box {
  height: 34px;
  width: 100%;
  padding: 0px 25px;
  .el-button {
    float: right;
  }
}
</style>
